import { mediaQuery } from '@clearscore/rainbow.tokens';

export const types = {
    MICRO: 'MICRO',
    TINY: 'TINY',
    MINI: 'MINI',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    BIG: 'BIG',
    HUGE: 'HUGE',
    MASSIVE: 'MASSIVE',
    JUMBO: 'JUMBO',
    GARGANTUAN: 'GARGANTUAN',
    RIDICULOUS: 'RIDICULOUS',
};

export const weights = {
    THIN: 'THIN',
    LIGHT: 'LIGHT',
    BOOK: 'BOOK',
    REGULAR: 'REGULAR',
    MEDIUM: 'MEDIUM',
    BOLD: 'BOLD',
    BLACK: 'BLACK',
};

export const spacings = {
    TIGHT: 'TIGHT',
    WIDE: 'WIDE',
    EXPLODED: 'EXPLODED',
};

export const tags = {
    DIV: 'div',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    P: 'p',
    SPAN: 'span',
    LABEL: 'label',
    LEGEND: 'legend',
};

export const presets = {
    J1: {
        type: [types.GARGANTUAN, types.RIDICULOUS],
        weight: weights.THIN,
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },
    J2: {
        type: [types.JUMBO, types.GARGANTUAN],
        weight: weights.THIN,
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },
    J3: {
        type: [types.MASSIVE, types.JUMBO],
        weight: weights.THIN,
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },
    J4: {
        type: [types.BIG, types.MASSIVE],
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },

    H1: {
        type: [types.BIG, types.HUGE],
        tag: tags.H1,
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },
    H2: {
        type: [types.MEDIUM, types.LARGE],
        tag: tags.H2,
        weight: weights.BOLD,
        breakpoints: [null, mediaQuery['rnb-mq-medium']],
    },
    H3: {
        type: types.SMALL,
        weight: weights.BOLD,
        tag: tags.H3,
    },
    H4: {
        type: types.MINI,
        weight: weights.BOLD,
        tag: tags.H4,
    },
    H5: {
        type: types.MINI,
        spacing: spacings.WIDE,
        tag: tags.H5,
        isUppercase: true,
    },
    H6: {
        type: types.TINY,
        weight: weights.BOLD,
        spacing: spacings.WIDE,
        tag: tags.H6,
        isUppercase: true,
    },

    BODY1: {
        type: types.SMALL,
        tag: tags.P,
    },
    BODY2: {
        type: types.MINI,
        tag: tags.P,
    },
    BODY3: {
        type: types.MINI,
        weight: weights.BOLD,
        tag: tags.P,
    },
    BODY4: {
        type: types.TINY,
        tag: tags.P,
    },
    BODY5: {
        type: types.TINY,
        weight: weights.BOLD,
        tag: tags.P,
    },
    BODY6: {
        type: types.MICRO,
        spacing: spacings.WIDE,
        tag: tags.P,
    },

    BUTTON1: {
        type: types.MINI,
        weight: weights.BOLD,
        spacing: spacings.WIDE,
    },
    BUTTON2: {
        type: types.TINY,
        weight: weights.BOLD,
        spacing: spacings.WIDE,
    },

    CAPTION: {
        type: types.TINY,
        spacing: spacings.WIDE,
    },

    OVERLINE: {
        type: types.TINY,
        spacing: spacings.EXPLODED,
        isUppercase: true,
    },
    LINK: {
        type: types.MINI,
        weight: weights.BOLD,
    },
};
